// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__b-E8X","index":"styles_index__WfEiH"};